import React from "react";

import { styled } from "@mui/material/styles";
import MuiSwitch from "@mui/material/Switch";

import { BaseLabel } from "components";

import { ContainerSwitch } from "./styles";

export interface SwitchProps {
  id?: string;
  dataTest?: string;
  label?: string;
  checked: boolean;
  required?: boolean;
  disabled?: boolean;
  onChange: () => unknown;
}

export const Switch: React.FC<SwitchProps> = ({
  id,
  dataTest,
  label,
  checked,
  disabled = false,
  onChange,
}) => {
  const KentaSwitch = styled(MuiSwitch)(() => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#30CD82",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#30CD82",
    },
  }));

  return (
    <ContainerSwitch>
      <KentaSwitch
        id={id}
        data-test={dataTest}
        checked={checked}
        disableRipple
        sx={{
          color: "#cbcbcb",
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: "#30CD82",
          },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            color: "#30CD82",
          },
          "&.Mui-disabled": {
            color: "#d1dbe3",
          },
        }}
        disabled={disabled}
        onChange={onChange}
      />
      <BaseLabel fontSize="16px" marginLeft="0px">
        {label ?? ""}
      </BaseLabel>
    </ContainerSwitch>
  );
};

export default Switch;
